import * as S from './UploadsFailedPopup.styles'
import useScreenSize from '../../../hooks/useScreenSize'
import { translateManager as t } from '../../../services/TranslateManager'
import { ReactComponent as ErrorIcon } from '../../../images/icons/error.svg'
import { Button } from 'mixtiles-web-common'
import { Grow } from '@mui/material'
import useOnMount from '../../../hooks/useOnMount'
import { analytics, EVENT_NAMES } from '../../../services/Analytics/Analytics'

type UploadsFailedPopupProps = {
  show: boolean
  onDismiss: () => void
}

// disableScrollLock: this replaces CompletingOrder's dialog in the same commit, so MUI
// rebuilds its container and would snapshot the body mid-handoff (COR-1325).
function UploadsFailedPopup({ show, onDismiss }: UploadsFailedPopupProps) {
  const isMediumScreen = useScreenSize('sm')

  useOnMount(() => {
    analytics.track(EVENT_NAMES.FAILED_UPLOADS_DISPLAYED, {
      Source: 'Completing Order',
    })
  })

  const Content = (
    <S.Container>
      {isMediumScreen && <S.CloseButton onClick={onDismiss} />}
      <ErrorIcon width={74} height={70} />
      <S.Title>
        {t.get('order.checkout.payment_errors.oops_order_failed')}
      </S.Title>
      <S.Description>
        {t.get('order.checkout.payment_errors.uploads_failed_text')}
      </S.Description>
      <S.Separator />
      <S.BottomText>
        {t.get('order.checkout.payment_errors.no_charge_text')}!
      </S.BottomText>
      <S.Cta>
        <Button size="large" onClick={onDismiss} fullWidth>
          {t.get('new_email_capture.continue')}
        </Button>
      </S.Cta>
    </S.Container>
  )

  return isMediumScreen ? (
    <S.Dialog
      open={show}
      onClose={onDismiss}
      TransitionComponent={Grow}
      transitionDuration={300}
      disableScrollLock
    >
      {Content}
    </S.Dialog>
  ) : (
    <S.Drawer open={show} onClose={onDismiss} anchor="bottom" disableScrollLock>
      {Content}
    </S.Drawer>
  )
}

export default UploadsFailedPopup
